import { ProposalStep3AllAttributesDto } from "@gap/backend/app-services/proposal/models/ProposalStep3Dto"
import { notNull } from "@gap/utils/utils"
import { labelForFieldName } from "features/proposals/proposalsUtils"
import { makeAutoObservable } from "mobx"
import { formHandler, FormHandlerConfig } from "reusable/mobx-store-utils/form-handlers/new/form-handler"
import ProposalsEditPaymentStore from "../ProposalsEditPaymentStore"
import { ProposalsEditPaymentBlockInputProps } from "./ProposalsEditPaymentBlockInput"

interface StoreProps extends ProposalsEditPaymentBlockInputProps {
   proposalEditPaymentStore: ProposalsEditPaymentStore
}

export default class ProposalsEditPaymentBlockInputStore {
   sp
   fields = {
      fieldValue: 0
   }
   stepData
   constructor(sp: StoreProps) {
      makeAutoObservable(this)
      this.sp = sp
      this.stepData = sp.proposalEditPaymentStore.getStepByRateType(sp.rateType) as ProposalStep3AllAttributesDto
   }

   get fieldLabel() {
      return `${labelForFieldName[this.sp.fieldName]}${this.sp.fieldType === 'required' ? '*' : this.sp.fieldType === 'optional' ? ' (optional)' : ''}`
   }

   get formHandler() {
      return formHandler(this.fields, {
         fieldValue: { type: 'number', min: 0, onValueChange: this.updateProposal, ...this.sp.formNumberConfig },
      } satisfies FormHandlerConfig)
   }

   updateProposal = async () => {
      this.stepData[this.sp.fieldName] = Number(notNull(this.fields.fieldValue))
      if (['stagedPaymentUpfront', 'stagedPaymentMilestone'].includes(this.sp.fieldName) && (this.stepData['stagedPaymentUpfront'] + this.stepData['stagedPaymentMilestone']) > 100) {
         this.formHandler.fieldValue.setError('')
         this.sp.proposalEditPaymentStore.markStepStatus(false)
         return
      }
      this.formHandler.fieldValue.resetError()
      this.sp.proposalEditPaymentStore.markStepStatus(true)

      await this.sp.proposalEditPaymentStore.update()
   }
}
